__turbopack_context__.v({
  "loader": "Ut03IW_loader",
  "spin": "Ut03IW_spin",
});
